module.exports = __webpack_public_path__ + "media/images/riders/small/PAULINE_FERRAND_PREVOT-8e6f7f23f5819ad670e4ebb8db398402.png";